import * as z from "zod";

import { CustomerSchema } from "../Customer/schema";

export const OrderItemClaimSchema = z.object({
  uuid: z.string(),
  orderItemId: z.string().toLowerCase(),
  customerSessionId: z.string(),
  customerId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type OrderItemClaim = z.infer<typeof OrderItemClaimSchema>;

export const CustomerSessionSchema = z.object({
  uuid: z.string(),
  createdAt: z.string(),
  completedAt: z.string().nullable(),
  paymentUuid: z.string().nullable(),
  customerId: z.string(),
});

export type CustomerSession = z.infer<typeof CustomerSessionSchema>;
export const BillSplitSchema = z.object({
  uuid: z.string(),
  finishedAt: z.coerce.date().nullable(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  ownerId: z.string(),
  customers: z.array(CustomerSchema),
  customerSessions: z.array(CustomerSessionSchema),
  customerTabId: z.string().toLowerCase(),
  orderItemClaims: z.array(OrderItemClaimSchema),
  remainderClaimerId: z.string().nullable(),
});
export type BillSplit = z.infer<typeof BillSplitSchema>;

export type OrderItemStatus =
  | "yours"
  | "others_paid"
  | "others_claimed"
  | "unclaimed"
  | "paid_at_till"
  | "unclaimable";
